import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    // Responsive grid: one cell fills full width, two+ cells wrap to columns.
    // `auto-fit + minmax(140px, 1fr)` lets 2 columns fit at typical mobile
    // widths (320px+ container) and collapses to one column only when truly
    // narrow. A 1-child grid always renders full-width because auto-fit
    // collapses the empty tracks.
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
      gap: Spacings.s8,
      width: '100%',
      boxSizing: 'border-box',
      [`@media (max-width: ${Breakpoints.xs - 1}px)`]: {
        gap: Spacings.s6,
      },
    },
  },
  { name: 'media-inputs-grid' }
);

export default useStyles;
